import { render, staticRenderFns } from "./TeethOpacity.vue?vue&type=template&id=05fab101&scoped=true&"
import script from "./TeethOpacity.vue?vue&type=script&lang=js&"
export * from "./TeethOpacity.vue?vue&type=script&lang=js&"
import style0 from "./TeethOpacity.vue?vue&type=style&index=0&id=05fab101&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fab101",
  null
  
)

export default component.exports